import script from "./AdminSystemStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminSystemStatus.vue?vue&type=script&setup=true&lang=js"

import "./AdminSystemStatus.vue?vue&type=style&index=0&id=31f664da&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31f664da"]])

export default __exports__